import { Fade, Grid } from '@mui/material';
import { RoutalLoader, RoutalPalette } from '@nx-smartmonkey/ui';
import React, { useEffect } from 'react';

import { useRetrieveActiveProject } from '../../../../hooks/project/useRetrieveActiveProject';
import { useRetrieveRightPanelInfo } from '../../../../hooks/right-panel/useRetrieveRightPanelInfo';
import { StyledRightPanel } from '../../shared/right-panel/StyledRightPanel';
import { useRetrieveDriver } from '../hooks/driver/useRetrieveDriver';
import { useRetrieveActivePlan } from '../hooks/plan-details/useRetrieveActivePlan';
import { DriverBody } from './DriverBody';
import { DriverHeader } from './DriverHeader';

type DriverRightPanelProps = {
  options?: React.ReactElement | any;
  warning?: React.ReactElement;
};

export const DriverRightPanel = ({ options, warning }: DriverRightPanelProps) => {
  const { data: activeProject } = useRetrieveActiveProject();
  const { data: activePlan } = useRetrieveActivePlan();

  const { detailId: driverId, detailType, cleanRightPanelInfo } = useRetrieveRightPanelInfo();

  const { data: driver, isLoading, error: retrieveDriverError } = useRetrieveDriver({ showErrorMessage: false });

  const onClose = () => {
    cleanRightPanelInfo();
  };

  const isOpen = () => detailType === `driver` && !!driverId;

  useEffect(() => {
    if (retrieveDriverError) {
      onClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [retrieveDriverError]);

  useEffect(() => {
    if (driver && driver.plan_id !== activePlan?.id) {
      onClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [driver]);

  return (
    <StyledRightPanel
      style={{
        height: `calc(100vh - 46px)`, //38 px of height plus +4+4 of floating design
        zIndex: 450,
        backgroundColor: RoutalPalette.neutral00,
        borderLeft: `1px solid ${RoutalPalette.neutral10}`,
        position: `relative`,
      }}
    >
      <Fade in={isOpen()} mountOnEnter>
        <Grid style={{ height: `100%` }}>
          <Grid
            container
            direction="column"
            style={{
              width: `400px`,
              height: `100%`,
              padding: `0`,
            }}
            wrap="nowrap"
          >
            {isLoading ? (
              <Grid
                container
                justifyContent="center"
                style={{ height: `100%`, overflow: `hidden` }}
                alignItems="center"
              >
                <RoutalLoader width={60} />
              </Grid>
            ) : (
              <>
                {driver && (
                  <>
                    <DriverHeader
                      driver={driver}
                      warning={warning}
                      options={options}
                      onClose={onClose}
                      activeProject={activeProject}
                    />

                    {activeProject ? (
                      <Grid item container style={{ height: `calc(100% - 60px)`, overflowY: `auto` }}>
                        <div style={{ width: `100%`, height: `100%` }}>
                          <DriverBody driver={driver} activeProject={activeProject} />
                        </div>
                      </Grid>
                    ) : null}
                  </>
                )}
              </>
            )}
          </Grid>
        </Grid>
      </Fade>
    </StyledRightPanel>
  );
};
